import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { IQuickActionsState } from '../store/quickActions.types'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { setResponse, setSelectedQuickActionButtonType } from '../store/quickActions.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveQuickActions() {
  const quickActionsState: IQuickActionsState = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton, selectedQuickActionButtonId } = quickActionsState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.quickActionsList && pcrDoc.patient?.quickActionsList.length) {
        const index = pcrDoc.patient?.quickActionsList?.findIndex((i) => i.key === selectedQuickActionButtonId)
        if (index !== -1) {
          pcrDoc.patient.quickActionsList[index] = selectedQuickActionButton
        } else {
          pcrDoc.patient?.quickActionsList.push(selectedQuickActionButton)
        }
      } else {
        pcrDoc.patient = { ...pcrDoc.patient, quickActionsList: [selectedQuickActionButton] }
      }
      const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setResponse(response))
      yield put(setSelectedQuickActionButtonType())
    } catch (e) {
      yield put(throwPcrException(`saveQuickActions() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveQuickActionsSaga() {
  yield takeLatest([QuickActionsConstants.SET_SELECTED_QUICK_ACTION_BUTTON], performWithMutexHOG, saveQuickActions)
}
